import { FlashMessageService } from "zoox-infra";
import { zPayCreateCardForm } from "zoox-components";
import CardService from "@/service/card-service";
import PaymentService from "@/service/payment-service";

export default {
  name: "CreateCardDialog",
  components: {
    "z-pay-create-card-form": zPayCreateCardForm
  },
  props: {
    openDialog: {
      type: Boolean
    },
    personId: {
      type: String,
      default: null
    },
    person: {
      type: Object,
      default: () => ({})
    },
    charge: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      cardService: new CardService(),
      paymentService: new PaymentService(),
      success: false
    };
  },
  methods: {
    async submitCard(data) {
      const card = data.card;
      const cards = await this.cardService.getCards();
      await this.cardService
        .createCard(card)
        .then(resp => {
          if (cards.find(x => x.gatewayCardId == resp.data.gatewayCardId)) {
            FlashMessageService.error(
              this.$t("INFRA.PORTAL_CUSTOM_ERRORS.CARD_409")
            );
            this.$emit("error");
          } else {
            FlashMessageService.success(
              this.$t("PAYMENT_SOLICITATION.CARD_ADDED")
            );
            this.$emit("success", resp.data);
          }
        })
        .catch(() => {
          FlashMessageService.error(this.$t("GLOBAL.CREDIT_CARD.INVALID_CARD"));
        });
      this.$emit("cardCreated", card);
    },
    close() {
      this.$emit("closeCardDialog");
    }
  }
};
